module.exports = __webpack_public_path__ + "img/new_tag.1ecca00a.svg";